import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import {
  faTiktok,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const IconLink = ({ title, children, className, img }) => (
  <div className={`icon-link ${className || ""}`}>
    {title && <span className="social-title">{title}</span>}
    {children}
  </div>
);

IconLink.Item = ({ path, icon, src, className }) => (
  <Link to={path || "#"}>
    <i className={icon} />
    <FontAwesomeIcon icon={icon} styles={{ color: "#ffffff" }} />
    <img className={className} src={src}></img>
  </Link>
);

export default IconLink;
